import PropTypes from "prop-types"
import styled from "styled-components"

const Intro = styled.div`
  margin-bottom: 96px;

  ${(props) => props.spacing && `margin-bottom: ${spacing[props.spacing]};`}

  ${(props) => props.type === "double" && Double}
  ${(props) => props.type === "small" && Small}
    ${(props) =>
    props.align === "center" &&
    `
      text-align: center;
      max-width: 280px;
      margin-left: auto;
      margin-right: auto;
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;

      @media (min-width: 768px) {
        max-width: 560px;
      }

      img {
        margin: 0.5rem 0;
      }
    `}
`

const Small = `
    max-width: 560px;
    margin: 0 auto 48px auto;

    &:last-child {
      margin-bottom: 0;
    }

    h2 {
      font: var(--h3);
    }
  `

const Double = `
    display: grid;

    @media (min-width: 768px) {
      gap: 96px;
      grid-template-columns: repeat(2, 1fr);
    }
  `

const spacing = {
  sm: "32px",
  md: "48px",
  lg: "64px",
  xl: "96px",
}

Intro.propTypes = {
  type: PropTypes.oneOf(["main", "small", "double"]),
  spacing: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
  align: PropTypes.oneOf(["left", "center"]),
}

Intro.defaultProps = {
  align: "left",
  spacing: "xl",
  type: "main",
}

export default Intro
